<script lang="ts">
  import View from './AnnouncementView.svelte';

  interface Props {
    features?: any[];
    onevent?: (payload: any) => void;
  }

  let { features = [], onevent } = $props();

  const onFinish = (): void => {
    onevent?.({ type: 'close' });
  };
</script>

<View {features} onfinish={onFinish} {onevent} />
